import axios from "./axiosConfig";
import { apis } from "./params";

export function getPlaFeedsService(_param: any) {
  return axios({
    method: "Get",
    url: apis.GET_LIST_OF_PLA_FEEDS + _param,
  });
}
// export function getPlaFeedService(_param: any) {
//     return axios({
//         "method": "Get",
//         "url": apis.GET_LIST_OF_PLA_FEED + _param,
//     })
// }

export function getPlaFeedByIdService(_param: any) {
  return axios({
    method: "Get",
    url: apis.GET_PLA_FEED_BY_ID + _param,
  });
}

export function createPlaFeedService(_data: any) {
  return axios({
    method: "Post",
    url: apis.CREATE_PLA_FEED,
    data: _data,
    headers: {
      ..._data.headers,
    },
  });
}

export function updatePlaFeedService(_data: any) {
  return axios({
    method: "Post",
    url: apis.UPDATE_PLA_FEED,
    data: _data,
    headers: {
      "Content-Type": "multipart/form-data",
      ..._data.headers,
    },
  });
}

export function downloadPlaDumpService(_param: any) {
  return axios({
    method: "Get",
    url: apis.DOWNLOAD_PLA_DUMP + _param,
  });
}
export function bulkPlaService(_data: any) {
  return axios({
    method: "Post",
    url: apis.BULK_PLA_FILE + _data.param,
    data: _data.data,
    headers: {
      "Content-Type": "multipart/form-data",
      ..._data.headers,
    },
  });
}

export function getPlaAuditHistoryService(msn: string) {
  return axios({
    method: "Get",
    url: apis.GET_PLA_AUDIT_HISTORY + msn,
  });
}

export function getPlaUploadStatusService(params: {
  batchId?: string;
  msn?: string;
  pageNumber?: number;
  pageSize?: number;
  status?: string;
  includeProducts?: boolean;
}) {
  const queryParams = new URLSearchParams();
  if (params.batchId) queryParams.append("batchId", params.batchId);
  if (params.msn) queryParams.append("msn", params.msn);
  if (params.pageNumber !== undefined && params.pageNumber !== null) queryParams.append("pageNumber", String(params.pageNumber));
  if (params.pageSize !== undefined && params.pageSize !== null) queryParams.append("pageSize", String(params.pageSize));
  if (params.status && params.status !== "ALL") queryParams.append("status", params.status);
  if (params.includeProducts !== undefined && params.includeProducts !== null) queryParams.append("includeProducts", String(params.includeProducts));

  return axios({
    method: "Get",
    url: `${apis.GET_PLA_UPLOAD_STATUS}${queryParams.toString()}`,
  });
}

export function getPlaAllBatchesService(params?: {
  pageNumber?: number;
  pageSize?: number;
}) {
  const queryParams = new URLSearchParams();
  if (params?.pageNumber !== undefined && params?.pageNumber !== null) {
    queryParams.append("pageNumber", String(params.pageNumber));
  }
  if (params?.pageSize !== undefined && params?.pageSize !== null) {
    queryParams.append("pageSize", String(params.pageSize));
  }

  return axios({
    method: "Get",
    url: `${apis.GET_PLA_ALL_BATCHES}${queryParams.toString()}`,
  });
}
